import { Subject } from 'rxjs/index';
var BaseActions = /** @class */ (function () {
    function BaseActions() {
        this.stopSubscription = new Subject();
        this.doneLoading = false;
    }
    BaseActions.prototype.ngOnDestroy = function () {
        this.stopSubscription.complete();
        this.stopSubscription.next(true);
    };
    BaseActions.prototype.containsErrors = function (message, error) {
        this.doneLoading = true;
        this.hasError = true;
        console.error(message, error);
    };
    return BaseActions;
}());
export { BaseActions };
